/*
 * Authors: mariushirjanu
 * Created: 28/07/2022
 */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { STATE_GLOBALPRODUCT_EDIT_GENERAL, STATE_GLOBALPRODUCT_EDIT_IMAGES, STATE_GLOBALPRODUCT_EDIT_SPECS, STATE_GLOBALPRODUCT_NEW_GENERAL } from '../../../shared/app-states';
import { GlobalProductService } from '../global-product.service';
import { IGlobalItem } from '../global-product-data.service';
import { GaWizard, IWizardStep } from '../../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../../shared/wizard/ga-wizard.service';
import { GlobalProductEditGeneralComponent } from './global-product-edit-general.component';
import { GlobalProductEditImagesComponent } from './global-product-edit-images.component';
import { GlobalProductEditSpecsComponent } from './global-product-edit-specs.component';
import { WIZARD_GLOBAL_PRODUCT_EDIT } from '../../../shared/app-wizards';

@Component({
  selector: 'global-product-edit',
  template: `
    <div class="globalproduct globalproduct-content">
      <wizard-wrapper [wizardTitle]="title" [wizardId]="wizardId"></wizard-wrapper>
    </div>
  `
})
export class GlobalProductEditComponent implements OnInit, OnDestroy {
  @Input() public newProduct:boolean;

  private wizard:GaWizard;
  public wizardId:string = WIZARD_GLOBAL_PRODUCT_EDIT;
  public title:string;
  private globalProduct:IGlobalItem;

  constructor(
    private globalProductService:GlobalProductService,
    private wizardService:GaWizardService
  ) {
    this.wizard = wizardService.getInstance(WIZARD_GLOBAL_PRODUCT_EDIT);
  }

  public ngOnInit():void {
    this.start();
  }

  private start = ():void => {
    this.globalProduct = this.globalProductService.product();
    this.title = this.newProduct || !this.globalProduct?.id ? 'New Global Product' : `Global Product ${this.globalProduct?.globalPart}`;
    this.initWizard();
  };

  private initWizard():void {
    const generalStep:IWizardStep = this.wizardService.createStep('general', 'General Info', GlobalProductEditGeneralComponent, !this.newProduct? STATE_GLOBALPRODUCT_EDIT_GENERAL : STATE_GLOBALPRODUCT_NEW_GENERAL, undefined, undefined, true);
    const imagesStep:IWizardStep = this.wizardService.createStep('images', 'Images', GlobalProductEditImagesComponent, STATE_GLOBALPRODUCT_EDIT_IMAGES, undefined, undefined, true);
    const specsStep:IWizardStep = this.wizardService.createStep('specs', 'Properties', GlobalProductEditSpecsComponent, STATE_GLOBALPRODUCT_EDIT_SPECS, undefined, undefined, true);

    const steps:IWizardStep[] = [generalStep];
    if(!this.newProduct){
      steps.push(imagesStep, specsStep);
    }
    this.wizard.steps(steps);
    this.wizard.sync();
  }

  public ngOnDestroy():void {
    this.wizard.clear();
  }
}